export const LANGUAGE_STORAGE_KEY = "language";
export const LANGUAGE_CHANGED_EVENT = "language_changed";
export const FALLBACK_LANGUAGE = "th";

export const SUPPORTED_LANGUAGES = [
    {
        code: "th",
        shortLabel: "TH",
        nativeLabel: "ไทย",
    },
    {
        code: "en",
        shortLabel: "EN",
        nativeLabel: "English",
    },
    {
        code: "my",
        shortLabel: "MY",
        nativeLabel: "မြန်မာ",
    },
    {
        code: "lo",
        shortLabel: "LO",
        nativeLabel: "ລາວ",
    },
    {
        code: "id",
        shortLabel: "ID",
        nativeLabel: "Indonesia",
    },
    {
        code: "ms",
        shortLabel: "MS",
        nativeLabel: "Bahasa Melayu",
    },
];

export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map(
    (language) => language.code
);

export const normalizeLanguage = (language) => {
    const value = `${language || ""}`.toLowerCase();
    const baseLanguage = value.split("-")[0];

    if (SUPPORTED_LANGUAGE_CODES.includes(value)) {
        return value;
    }

    if (SUPPORTED_LANGUAGE_CODES.includes(baseLanguage)) {
        return baseLanguage;
    }

    return FALLBACK_LANGUAGE;
};
